/**
 * The Help topics: markdown files opened in the editor itself, so the
 * documentation is rendered by the code it documents. Bundled with the page
 * and loaded on first use, which also makes them available offline.
 */
import type { HelpDoc } from './types'

/**
 * The topics, by the id the menu commands use. An explicit map rather than
 * whatever is in the folder: a typo in a command id fails here.
 */
export const HELP_TOPICS: Record<string, { file: string; title: string }> = {
  whatsNew: { file: 'whats-new.md', title: "What's New" },
  quickStart: { file: 'quick-start.md', title: 'Quick Start' },
  markdownReference: { file: 'markdown-reference.md', title: 'Markdown Reference' },
  customThemes: { file: 'custom-themes.md', title: 'Custom Themes' },
  images: { file: 'images.md', title: 'Use Images' },
  topics: { file: 'topics.md', title: 'More Topics' },
  credits: { file: 'credits.md', title: 'Credits' },
  changeLog: { file: 'changelog.md', title: 'Change Log' },
}

const files = import.meta.glob('../../docs/*.md', { query: '?raw', import: 'default' }) as Record<
  string,
  () => Promise<string>
>

export async function helpTopic(id: string): Promise<HelpDoc | null> {
  const topic = HELP_TOPICS[id]
  const load = topic ? files[`../../docs/${topic.file}`] : undefined
  if (!topic || !load) return null
  try {
    return { title: topic.title, content: await load() }
  } catch {
    return null
  }
}

/** For the test that checks every topic has a file behind it. */
export const HELP_FILES = Object.keys(files)
